// Ad helpers: fetching + weighted random selection by priority.

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export async function fetchActiveAds() {
  try {
    const res = await fetch(`${API_URL}/api/ads`);
    if (!res.ok) return [];
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}

// Pick one ad weighted by priority. Priority <= 0 is treated as 0; if all
// weights are zero we fall back to uniform random.
export function pickWeightedAd(ads) {
  if (!Array.isArray(ads) || ads.length === 0) return null;
  const weights = ads.map(a => Math.max(0, Number(a.priority) || 0));
  const total = weights.reduce((s, w) => s + w, 0);
  if (total <= 0) {
    return ads[Math.floor(Math.random() * ads.length)];
  }
  let r = Math.random() * total;
  for (let i = 0; i < ads.length; i++) {
    r -= weights[i];
    if (r <= 0) return ads[i];
  }
  return ads[ads.length - 1];
}

// Pick up to `count` distinct ads, weighted by priority, without duplicates.
export function pickWeightedAds(ads, count) {
  if (!Array.isArray(ads) || ads.length === 0 || count <= 0) return [];
  const pool = ads.slice();
  const picked = [];
  const n = Math.min(count, pool.length);
  for (let i = 0; i < n; i++) {
    const chosen = pickWeightedAd(pool);
    if (!chosen) break;
    picked.push(chosen);
    const idx = pool.indexOf(chosen);
    if (idx >= 0) pool.splice(idx, 1);
  }
  return picked;
}
